import PropTypes from 'prop-types';

import LegendItem from './LegendItem/legendItem';
import styles from './legend.module.scss';

const Legend = ({ datasets }) => {
  return (
    <div className={styles['legend-container']}>
      {datasets.map((dataset) => {
        const { label, backgroundColor } = dataset;
        return <LegendItem key={label} label={label} color={backgroundColor} />;
      })}
    </div>
  );
};

Legend.propTypes = {
  datasets: PropTypes.array,
};

export default Legend;
